import { useMutation } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { SCHOOL_INSTALLMENTS_CREATE } from "../../apiRoutes";
import { toast } from "sonner";

export interface PdcDataItem {
  year: number;
  pdcNumber: number;
  pdcDate: string; // ISO date string (YYYY-MM-DD)
  pdcAmount: number;
  pdcRemarks?: string | null;
}

export interface InstallmentItemPayload {
  schoolId: string;
  commercialId: string;
  year: number;
  installmentNumber: number;
  expectedDueDate: string; // ISO date string (YYYY-MM-DD)
  installmentAmount: number;
  isPdcCheckAvailable: boolean;
  pdcData?: PdcDataItem[];
}

export interface CreateSchoolInstallmentsPayload {
  installmentsData: InstallmentItemPayload[];
}

export interface CreateSchoolInstallmentsResponse {
  data?: unknown;
  message?: string;
}

export const useCreateSchoolInstallmentsMutation = (options?: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: async (payload: CreateSchoolInstallmentsPayload) => {
      const response = await axiosAuth.post<CreateSchoolInstallmentsResponse>(
        SCHOOL_INSTALLMENTS_CREATE,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Installments saved successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message || error?.response?.data?.message || "Failed to save installments";
      toast.error(message);
    },
  });
};


